import { DATE_FORMAT_LONG } from 'constants/defaultConstants';
import { format } from 'date-fns';
import { translate } from 'hooks/useTranslate';
import { Council, Document } from 'types';
import { CouncilSignatureTypes } from 'types/Council';

const NOT_SENT_TO_SIGNATURE = translate('NotSentToSignature');
const SENT_TO_SIGNATURE = translate('SentToSignature');

const formatDate = (date: Date) => format(new Date(date), DATE_FORMAT_LONG);

export const getSignatureDescription = (
  council: Council,
  document: Document,
  signatureType: CouncilSignatureTypes
): string => {
  if (signatureType === CouncilSignatureTypes.ACT) {
    return council?.actSignature?.sentDate
      ? SENT_TO_SIGNATURE
      : NOT_SENT_TO_SIGNATURE;
  }

  if (signatureType === CouncilSignatureTypes.CERTIFICATE) {
    return council?.actCertificateSignature?.sentDate
      ? SENT_TO_SIGNATURE
      : NOT_SENT_TO_SIGNATURE;
  }

  return document?.name || '-';
};
